module.exports = __webpack_public_path__ + "img/titleA.7481345f.png";